// frontend/src/components/Layout/Footer.jsx
import { Link } from 'react-router-dom';
import config from '../../config';
import { Sun, Phone, Mail, MapPin, ChevronDown, ChevronUp } from 'lucide-react';
import { useState, useEffect } from 'react';
import api from '../../services/api';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [settings, setSettings] = useState(null);
  const [footerProducts, setFooterProducts] = useState([]);
  const [footerServices, setFooterServices] = useState([]);
  const [footerCompany, setFooterCompany] = useState([]);
  
  // State برای منوهای کشویی در موبایل
  const [openSections, setOpenSections] = useState({
    products: false,
    services: false,
    company: false
  });

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const [productsRes, servicesRes, companyRes] = await Promise.all([
          fetch(config.getApiUrl('/cms/menus/?position=footer_products')).then(r => r.json()),
          fetch(config.getApiUrl('/cms/menus/?position=footer_services')).then(r => r.json()),
          fetch(config.getApiUrl('/cms/menus/?position=footer_company')).then(r => r.json()),
        ]);
        
        const extractData = (data) => {
          if (Array.isArray(data)) return data;
          if (data?.results) return data.results;
          return [];
        };
        
        setFooterProducts(extractData(productsRes));
        setFooterServices(extractData(servicesRes));
        setFooterCompany(extractData(companyRes));
        
        console.log('Footer Products:', extractData(productsRes));
        console.log('Footer Services:', extractData(servicesRes));
        console.log('Footer Company:', extractData(companyRes));
        
      } catch (error) {
        console.error('Error fetching footer:', error);
      }
    };
    
    fetchFooterData();
  }, []);

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
          
          {/* ستون اول - درباره ما (همیشه باز) */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Sun className="w-7 h-7 md:w-8 md:h-8 text-yellow-500" />
              <span className="text-xl md:text-2xl font-bold text-white">
                سان ایران
              </span>
            </Link>
            <p className="text-gray-400 mb-4 md:mb-6 leading-relaxed text-sm md:text-base">
              بزرگترین پلتفرم تخصصی خرید و فروش تجهیزات انرژی خورشیدی در ایران. 
              با بیش از ۱۰ سال تجربه در صنعت انرژی‌های تجدیدپذیر.
            </p>
            <div className="space-y-2 md:space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" />
                <span className="text-sm md:text-base">۰۲۱-۸۸۳۱۵۶۵۸</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" />
                <span className="text-sm md:text-base text-wrap break-all">info@suniran.tech</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" />
                <span className="text-sm md:text-base">تهران، سهروردی</span>
              </div>
            </div>
          </div>

          {/* ستون محصولات - با قابلیت باز/بسته در موبایل */}
          <div>
            {/* دکمه عنوان در موبایل */}
            <button
              onClick={() => toggleSection('products')}
              className="md:hidden w-full flex items-center justify-between text-white font-bold py-3 border-b border-gray-800"
            >
              <span className="text-base">محصولات</span>
              {openSections.products ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </button>
            
            {/* عنوان دسکتاپ */}
            <h3 className="hidden md:block text-white font-bold mb-4 text-lg">محصولات</h3>
            
            {/* لینک‌ها - در موبایل با شرط باز بودن نمایش داده می‌شوند */}
            <div className={`mt-3 md:mt-0 space-y-2 ${openSections.products ? 'block' : 'hidden md:block'}`}>
              {footerProducts.length === 0 ? (
                <>
                  <li className="list-none py-1">
                    <Link to="/category/solar-panels" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      پنل‌های خورشیدی
                    </Link>
                  </li>
                  <li className="list-none py-1">
                    <Link to="/category/inverter" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      اینورترها
                    </Link>
                  </li>
                  <li className="list-none py-1">
                    <Link to="/category/batteries" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      باتری‌ها
                    </Link>
                  </li>
                </>
              ) : (
                footerProducts.map((item) => (
                  <li key={item.id} className="list-none py-1">
                    <Link 
                      to={item.url} 
                      className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))
              )}
            </div>
          </div>

          {/* ستون خدمات - با قابلیت باز/بسته در موبایل */}
          <div>
            <button
              onClick={() => toggleSection('services')}
              className="md:hidden w-full flex items-center justify-between text-white font-bold py-3 border-b border-gray-800"
            >
              <span className="text-base">خدمات</span>
              {openSections.services ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </button>
            
            <h3 className="hidden md:block text-white font-bold mb-4 text-lg">خدمات</h3>
            
            <div className={`mt-3 md:mt-0 space-y-2 ${openSections.services ? 'block' : 'hidden md:block'}`}>
              {footerServices.length === 0 ? (
                <>
                  <li className="list-none py-1">
                    <Link to="/installation/request" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      نصب و راه‌اندازی
                    </Link>
                  </li>
                  <li className="list-none py-1">
                    <Link to="/contact" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      مشاوره رایگان
                    </Link>
                  </li>
                </>
              ) : (
                footerServices.map((item) => (
                  <li key={item.id} className="list-none py-1">
                    <Link 
                      to={item.url} 
                      className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))
              )}
            </div>
          </div>

          {/* ستون شرکت - با قابلیت باز/بسته در موبایل */}
          <div>
            <button
              onClick={() => toggleSection('company')}
              className="md:hidden w-full flex items-center justify-between text-white font-bold py-3 border-b border-gray-800"
            >
              <span className="text-base">شرکت</span>
              {openSections.company ? (
                <ChevronUp className="w-4 h-4" />
              ) : (
                <ChevronDown className="w-4 h-4" />
              )}
            </button>
            
            <h3 className="hidden md:block text-white font-bold mb-4 text-lg">شرکت</h3>
            
            <div className={`mt-3 md:mt-0 space-y-2 ${openSections.company ? 'block' : 'hidden md:block'}`}>
              {footerCompany.length === 0 ? (
                <>
                  <li className="list-none py-1">
                    <Link to="/about" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      درباره ما
                    </Link>
                  </li>
                  <li className="list-none py-1">
                    <Link to="/contact" className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1">
                      تماس با ما
                    </Link>
                  </li>
                </>
              ) : (
                footerCompany.map((item) => (
                  <li key={item.id} className="list-none py-1">
                    <Link 
                      to={item.url} 
                      className="text-sm text-gray-400 hover:text-yellow-500 transition-colors block py-1"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))
              )}
            </div>
          </div>
        </div>

        {/* کپی‌رایت - واکنش‌گرا */}
        <div className="border-t border-gray-800 mt-6 md:mt-12 pt-6 md:pt-8 text-center text-xs md:text-sm text-gray-500">
          <p>© {currentYear} سان ایران. تمامی حقوق محفوظ است.</p>
        </div>
      </div>
    </footer>
  );
};